import * as React from "react";
import Svg, { Path } from "react-native-svg";

const S = (props) => (
  <Svg
    width={77}
    height={105}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M16.014 102.411c-4.337-.837-8.142-1.902-11.338-3.12-2.587-.989-4.261-3.5-4.261-6.24V77.986c0-2.968 3.044-4.946 5.707-3.805 3.424 1.522 7 2.664 10.653 3.577 5.707 1.446 11.11 2.13 16.132 2.13 6.772 0 10.349-1.674 10.881-5.022.305-1.902-.456-3.88-1.826-5.25-1.065-1.066-2.663-2.13-4.642-3.12-2.206-1.065-5.63-2.663-10.349-4.718-9.207-3.957-15.827-8.294-19.936-13.012C2.925 44.047.871 38.188.871 31.187c0-5.859 1.598-11.11 4.87-15.675C9.013 10.947 13.58 7.37 19.438 4.783 25.298 2.196 32.07.978 39.68.978c6.24 0 11.795.457 16.588 1.522 3.957.837 7.762 1.979 11.49 3.577 1.522.685 2.512 2.13 2.512 3.804v17.73c0 2.13-2.207 3.5-4.11 2.663-6.924-3.12-13.925-4.717-21.153-4.717-3.805 0-6.773.532-9.056 1.598-2.282 1.065-3.424 2.663-3.424 4.717 0 2.055.99 3.729 3.044 5.023 2.054 1.293 5.86 3.043 11.566 5.326l3.12 1.294c6.696 2.74 11.87 5.478 15.523 8.142 3.653 2.663 6.24 5.783 7.838 9.36 1.598 3.576 2.435 7.989 2.435 13.392 0 9.36-3.425 16.664-10.197 21.99-6.772 5.327-17.045 7.914-30.742 7.914a96.166 96.166 0 0 1-19.099-1.902Z"
      fill="#fff"
    />
  </Svg>
);

export default S;
